module.exports = __webpack_public_path__ + "img/icon_store_g.907d28c7.svg";